import React from 'react';

export const PraticheStats = ({ stats }) => (
  <div className="grid grid-cols-3 sm:grid-cols-6 gap-2 mb-5">
    {[
      { label: 'Totale', value: stats.totale, color: 'text-slate-800' },
      { label: 'Da Lavorare', value: stats.da_lavorare, color: 'text-slate-500' },
      { label: 'Istruttoria', value: stats.in_istruttoria, color: 'text-amber-600' },
      { label: 'Approvate', value: stats.approvata, color: 'text-green-600' },
      { label: 'Erogate', value: stats.erogata, color: 'text-emerald-600' },
      { label: 'Rifiutate', value: stats.rifiutata, color: 'text-red-600' },
    ].map(s => (
      <div key={s.label} className="bg-white rounded-xl border border-slate-200 p-3 text-center">
        <p className={`text-lg font-bold ${s.color}`}>{s.value}</p>
        <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider">{s.label}</p>
      </div>
    ))}
  </div>
);
